export const types = {
  'UI/SET_CSRF_TOKEN': 'UI/SET_CSRF_TOKEN',
  'UI/SET_SETTINGS': 'UI/SET_SETTINGS'
}
